module.exports = __webpack_public_path__ + "static/media/5.6_preview.d1303569.png";